// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentHeadingBox_wrapper__3oVUl"};